import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ar from '../locales/ar/translation.json';
import bn from '../locales/bn/translation.json';
import en from '../locales/en/translation.json';
import es from '../locales/es/translation.json';
import fa from '../locales/fa/translation.json';
import fil from '../locales/fil/translation.json';
import fr from '../locales/fr/translation.json';
import hi from '../locales/hi/translation.json';
import ja from '../locales/ja/translation.json';
import ms from '../locales/ms/translation.json';
import pt from '../locales/pt/translation.json';
import ru from '../locales/ru/translation.json';
import th from '../locales/th/translation.json';
import tr from '../locales/tr/translation.json';
import uk from '../locales/uk/translation.json';
import vi from '../locales/vi/translation.json';
import zh from '../locales/zh/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      bn: { translation: bn },
      en: { translation: en },
      es: { translation: es },
      fa: { translation: fa },
      fil: { translation: fil },
      fr: { translation: fr },
      hi: { translation: hi },
      ja: { translation: ja },
      ms: { translation: ms },
      pt: { translation: pt },
      ru: { translation: ru },
      th: { translation: th },
      tr: { translation: tr },
      uk: { translation: uk },
      vi: { translation: vi },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language',
    },
  });

export default i18n;
